module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/og-aoj_d-14723526e345ee54200281b7df501a58.png";